<template>
  <div class="avatar flex-center">
    <el-image
      v-if="imgObj.img"
      ref="previewImg"
      style="border-radius: 6px"
      :style="{ width: '80px', height: '80px' }"
      :src="imgObj.img"
      :preview-src-list="[imgObj.img]"
    />
    <div class="operate flex-center padding-x-10">
      <i
        class="el-icon-zoom-in color-fff font-weight font-18 margin-right-15"
        @click.stop="handlePictureCardPreview"
      ></i>
      <i
        class="el-icon-download color-fff font-weight font-18 margin-right-15"
        @click.stop="handleDownload(imgObj)"
      ></i>
      <i
        class="el-icon-delete color-fff font-weight font-18"
        @click.stop="handleRemove(imgObj.id)"
      ></i>
    </div>
  </div>
</template>

<script >
import { ref } from '@vue/composition-api';
import { Message } from 'element-ui';
const __sfc_main = {};
__sfc_main.props = {
  imgObj: {
    type: Object,
    default: () => {}
  },
  previewList: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const previewImg = ref(null);
  // 预览
  const handlePictureCardPreview = () => {
    if (props.imgObj.type === 'user-fission') {
      // 用户助力
      emits('previewImg');
    } else {
      previewImg.value.showViewer = true;
      console.log('previewImg.value', previewImg.value);
    }
  };
  const handleRemove = id => {
    // imageUrl.value = ''
    emits('remove', id);
  };
  const downloadIamge = (imgsrc, imgname) => {
    const image = new Image();
    // img是可以跨域的，crossOrigin="anonymous"允许跨域
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = imgsrc;
    image.onload = () => {
      // 创建一个canvas画布，并设置其宽高为图片的宽高
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      // 绘制图片
      context.drawImage(image, 0, 0, image.width, image.height);
      // 得到图片的base64编码
      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      // 名称设置
      a.download = imgname;
      // 将生成的URL设置为a.href属性
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      Message.success('下载中... 请注意浏览器下载内容');
    };
  };
  // 下载附件
  const handleDownload = item => {
    // const arr = item.split('.')
    // const type = arr[arr.length - 1]
    // const arr1 = ['jpg', 'png', 'jpeg']
    // if (arr1.includes(type)) {
    //   window.open(item)
    //   return
    // }
    // window.location.href = item
    // Message.success('下载中... 请注意浏览器下载内容')
    downloadIamge(item.img, item.imgName);
  };
  return {
    previewImg,
    handlePictureCardPreview,
    handleRemove,
    handleDownload
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .avatar {
    &:hover {
      .operate {
        visibility: visible;
      }
    }

    width: 100px;
    height: 100px;
    display: block;
    position: relative;
    background: rgb(217, 236, 255);
    border-radius: 6px;
  }

  .operate {
    visibility: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    z-index: 100;
    box-sizing: border-box;
    background-color: #909399;
  }
</style>
